/**
 * Carbon Plugin 공통 코드 상수 (API 미제공 분만)
 * - carbon_common_codes(API)에 있는 코드는 codes/carbonCodes.js(CarbonCodes) 사용
 * - 이 파일에는 API에 없는 고정 목록만 유지: REGION fallback, Scope 1/2/3 카테고리
 */

// ==================== Private Variables ====================

// scope 1 카테고리 (GHG 프로토콜 고정 목록, API 그룹 없음)
const SCOPE_1_CATEGORIES = [
    { value: "stationary_combustion", text: "고정 연소" },
    { value: "mobile_combustion", text: "이동 연소" },
    { value: "fugitive_emissions", text: "비산 배출" },
    { value: "process_emissions", text: "공정 배출" },
];

// scope 2 카테고리 (GHG 프로토콜 고정 목록, API 그룹 없음)
const SCOPE_2_CATEGORIES = [
    { value: "purchased_electricity", text: "구매 전력" },
    { value: "purchased_steam", text: "구매 증기" },
    { value: "purchased_heating", text: "구매 난방" },
    { value: "purchased_cooling", text: "구매 냉방" },
];

// scope 3 카테고리 (GHG 프로토콜 고정 목록, API 그룹 없음)
const SCOPE_3_CATEGORIES = [
    { value: "cat1_purchased_goods", text: "구매 상품 및 서비스" },
    { value: "cat2_capital_goods", text: "자본재" },
    { value: "cat3_fuel_energy", text: "연료 및 에너지 관련 활동" },
    { value: "cat4_upstream_transport", text: "상류 운송 및 유통" },
    { value: "cat5_waste", text: "운영 폐기물" },
    { value: "cat6_business_travel", text: "출장" },
    { value: "cat7_employee_commute", text: "직원 통근" },
    { value: "cat8_upstream_leased", text: "상류 임차 자산" },
    { value: "cat9_downstream_transport", text: "하류 운송 및 유통" },
    { value: "cat10_processing", text: "판매 제품 가공" },
    { value: "cat11_use_of_products", text: "판매 제품 사용" },
    { value: "cat12_eol_products", text: "판매 제품 폐기" },
    { value: "cat13_downstream_leased", text: "하류 임차 자산" },
    { value: "cat14_franchises", text: "프랜차이즈" },
    { value: "cat15_investments", text: "투자" },
];

// ==================== Getters ====================

/**
 * scope 1 카테고리 목록 조회
 * @returns {Array} scope 1 카테고리 배열
 */
export function getScope1Categories() {
    return SCOPE_1_CATEGORIES;
}

/**
 * scope 2 카테고리 목록 조회
 * @returns {Array} scope 2 카테고리 배열
 */
export function getScope2Categories() {
    return SCOPE_2_CATEGORIES;
}

/**
 * scope 3 카테고리 목록 조회
 * @returns {Array} scope 3 카테고리 배열
 */
export function getScope3Categories() {
    return SCOPE_3_CATEGORIES;
}
